import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, tap} from 'rxjs';
import {API_URL} from '../constants';

@Injectable({
    providedIn: 'root',
})
export class ChapterApiService {
    private apiUrl = `${API_URL}` + 'chapters';

    constructor(private http: HttpClient) {
    }

    createChapter(chapterData: any): Observable<any> {
        return this.http.post<any>(this.apiUrl, chapterData);
    }

    // Call the backend API to validate login credentials
    getChapterData(id: string): Observable<any> {
        const cached = sessionStorage.getItem("chapter_" + id);
        if (cached) {
            return of(JSON.parse(cached));
        }
        return this.http.get<any>(`${this.apiUrl}/${id}`).pipe(
            tap(data => sessionStorage.setItem("chapter_" + id, JSON.stringify(data)))
        );
    }


    // Call the backend API to validate login credentials
    updateWelcomeNote(id: string, chapterData: any): Observable<any> {
        return this.http.put<any>(this.apiUrl + '/' + id, chapterData);
    }

    getData(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}`);
    }

    updateStripeKeys(id: string, stripePublicKey: string, stripeSecretKey: string): Observable<any> {
        return this.http.put<any>(
            `${this.apiUrl}/${id}/stripe-keys`,
            { stripePublicKey, stripeSecretKey }
        );
    }

}
